import styles from "./styles/input.module.scss";

export function FormInput(props: {
  label?: string;
  placeholder?: string;
  name?: string;
  type?: "text" | "email" | "number" | "date" | "time";
  required?: boolean;
  width?: number | string;
}) {
  return (
    <div className={styles.input}>
      {props.label ?? <label className={styles.label}>{props.label}</label>}
      <input
        placeholder={props.placeholder}
        name={props.name}
        type={props.type}
        required={props.required}
        onChange={() => {}}
        width={props.width}
      />
    </div>
  );
}
